import {_, React, observer, observable, computed, IDisposer, action, useLocalStore, useEffect, useLayoutEffect, classNames, useAsObservableSource, Popover2} from '@api'
import {Button, Menu, MenuItem} from '@blueprintjs/core'
import {usePresentationModeContentStore} from './'
import {icons, StoresInstance} from '@stores'
import {PrimaryIconButton} from 'centric-ui-components'
import * as css from './PresentationMenu.css'

/// region Components

interface MyProps {
  className?: string
}

export const PresentationSettingsToolbarButton = observer<MyProps>(function PresentationSettingsToolbarButton({className}) {
  const {generateReport, clearReport} = usePresentationModeContentStore()

  return (<Popover2
    interactionKind='hover'
    className={classNames(css.root, className)}
    position='bottom'
    content={<div className={css.panel}>
      <Menu>
        <MenuItem icon={'new-drawing'} text='Generate Report' onClick={generateReport}/>
        <MenuItem icon={icons.clear} text='Clear' onClick={clearReport}/>
      </Menu>
    </div>}
  >
    <PrimaryIconButton icon='menu' tooltipPosition='left' tooltipStyle='mui' tooltip={'Presentation Settings'}/>
  </Popover2>)
})
/// endregion




// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/PresentationMode/PresentationMenu.tsx